export const version = "transactions/5.0.11";
//# sourceMappingURL=_version.js.map